var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94043 8L10.8154 11.875C10.9092 11.9688 10.9092 12.125 10.8154 12.25L10.1279 12.9375C10.0029 13.0312 9.84668 13.0312 9.75293 12.9375L9.09668 12.2812L5.90918 9.0625L2.03418 12.9375C1.94043 13.0312 1.78418 13.0312 1.65918 12.9375L0.97168 12.25C0.87793 12.125 0.87793 11.9688 0.97168 11.875L4.84668 8L0.97168 4.15625C0.87793 4.0625 0.87793 3.90625 0.97168 3.78125L1.65918 3.09375C1.78418 3 1.94043 3 2.03418 3.09375L5.90918 6.96875L9.75293 3.09375C9.84668 3 10.0029 3 10.1279 3.09375L10.8154 3.78125C10.9092 3.90625 10.9092 4.0625 10.8154 4.15625L10.1592 4.8125L6.94043 8Z"
  })));
};
export default __webpack_public_path__ + "assets/033dbd787b86322f2834e9131b3760cf.svg";
export { SvgClose as ReactComponent };


// WEBPACK FOOTER //
// ./components/toast/icons/close.svg